var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 73 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0059 2.9394L43.8384 4.73192C45.5468 6.40136 47.9456 7.17454 50.3157 6.82108L52.8609 6.43923C56.9745 5.82068 60.824 8.59782 61.5016 12.6657L61.9216 15.1841C62.3129 17.5289 63.7954 19.5549 65.9238 20.65L68.208 21.824C71.9017 23.7238 73.3715 28.2114 71.5072 31.9006L70.3555 34.1854C69.2834 36.3124 69.2834 38.815 70.3555 40.942L71.5072 43.2269C73.3683 46.9161 71.8985 51.4037 68.208 53.3035L65.9238 54.4774C63.7954 55.5725 62.3129 57.5986 61.9216 59.9434L61.5016 62.4617C60.824 66.5328 56.9745 69.3068 52.8609 68.6882L50.3157 68.3064C47.9456 67.9497 45.5436 68.7229 43.8384 70.3955L42.0059 72.188C39.044 75.0851 34.2878 75.0851 31.3259 72.188L29.4934 70.3955C27.7849 68.7261 25.3862 67.9529 23.016 68.3064L20.4709 68.6882C16.3573 69.3068 12.5078 66.5296 11.8301 62.4617L11.4102 59.9434C11.0189 57.5986 9.53633 55.5725 7.40796 54.4774L5.1237 53.3035C1.43008 51.4037 -0.0397373 46.9161 1.82457 43.2269L2.97625 40.942C4.04838 38.815 4.04838 36.3124 2.97625 34.1854L1.82457 31.9006C-0.0365558 28.2114 1.43326 23.7238 5.1237 21.824L7.40796 20.65C9.53633 19.5549 11.0189 17.5289 11.4102 15.1841L11.8301 12.6657C12.5078 8.59467 16.3573 5.82068 20.4709 6.43923L23.016 6.82108C25.3862 7.17769 27.7881 6.40451 29.4934 4.73192L31.3259 2.9394C34.2878 0.0423358 39.044 0.0423358 42.0059 2.9394Z",
    fill: "currentColor",
    stroke: "#263322",
    strokeWidth: 0.766607,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.5e2dba0228944b39fe1f7046bc0841b2.svg";
export { ForwardRef as ReactComponent };